import React                from 'react';
import PropTypes            from 'prop-types';
import Flux                 from '../../../flux/Flux';
import Translations         from '../../../utils/Translations';
import {VXButtonLineConfig} from '../../SimpleElements/VXButton/VXButtonConfig';
import STYLES               from '../../SimpleElements/VXButton/EnumVXButton';
import VXButtonOutline      from '../../SimpleElements/VXButton/Presets/VXButtonOutline';
import UrlBuilder           from '../../../utils/UrlBuilder';
import {trackClick}         from '../../../utils/GAHelper';
import withSuspense         from '../../HigherOrderComponents/Utility/withSuspense';

const CamShowsFeatured = React.lazy(() => import('../../CamShows/CamShowsFeatured'));
const CamShowsItem     = React.lazy(() => import('../../CamShows/CamShowsItem'));

function getTranslation(text, ...args) {
	return Translations.get(`cam_shows.${text}`, ...args);
}

class CamShowsBlock extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			featuredShows: [],
			shows:         [],
			bgImage:       this.getBgImage(),
		};

		this.loadCamShows   = this.loadCamShows.bind(this);
		this.onWindowResize = this.onWindowResize.bind(this);
	}

	componentDidMount() {
		this.loadCamShows();
		Flux.Browser.addWindowResizeListener(this.onWindowResize);
	}

	componentWillUnmount() {
		Flux.Browser.removeWindowResizeListener(this.onWindowResize);
	}

	loadCamShows() {
		const now         = new Date();
		now.setMinutes(0,0,0);
		const endDateFrom = now.toISOString();
		const dateTo      = new Date();
		dateTo.setDate(now.getDate() + 8 * 7);
		dateTo.setHours(23, 59, 59, 999);
		const startDateTo = dateTo.toISOString();
		const order       = 'ASC';

		Flux.Vxql.getCamShows({
			endDateFrom, order, startDateTo, callback: (data) => {
				const list = data.data.chatShows.getShowList;
				if (list.total) {
					const counter       = [];
					let filteredShows   = list.shows.filter(item => item && !item.isInternal); //filter null
					filteredShows       = filteredShows.map(show => { // because of multiple shows per model, every ticket shoudl have a different cover image. therefore add occurence to define sedcards index
						counter.push(show.actorId);
						return {
							...show,
							count:     filteredShows.filter(item => item.actorId === show.actorId).length,
							occurence: (counter.filter(item => item === show.actorId).length - 1) % filteredShows.filter(item => item.actorId === show.actorId).length
						};
					});
					const featuredShows = filteredShows.filter(item => item.isFeatured || item.isAutoFeatured);
					this.setState({featuredShows, shows: filteredShows});
				}
			}
		}, true);
	}

	onWindowResize() {
		const bgImage = this.getBgImage();
		this.setState({bgImage});
	}

	getBgImage() {
		if (window.innerWidth < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.sm) {
			return '/assets/img/camshows/mobile-module.webp';
		}
		return '/assets/img/camshows/desktop-module.webp';
	}

	getButton() {
		return <VXButtonOutline
			line1={[new VXButtonLineConfig(getTranslation('module-button'))]}
			size={STYLES.SIZE.SMALL}
			link={UrlBuilder.buildCamShowsRoute()}
			callback={() => {
				trackClick('camshows', UrlBuilder.buildCamShowsRoute());
			}}
		/>;
	}

	render() {
		if (this.state.featuredShows.length < 1 && this.state.shows.length < 1) {
			return null;
		}
		const hasFeatured = this.state.featuredShows.length > 0;
		const hasShows    = this.state.shows.length > 0;
		return (
            withSuspense(
                <section className={'cam-shows-module' + (hasFeatured ? '' : ' cam-shows-module--no-features')} id='cam-shows-block'
                    ref={(ref) => typeof this.props.parentCallback === 'function' ? this.props.parentCallback(ref) : null}>
                    <div className='cam-shows-module__bg-wrapper'>
                        <img loading={this.props.lazyImageLoading ? 'lazy' : 'eager'} className='cam-shows-module__bg' src={this.state.bgImage}/>
                    </div>
                    <div className='cam-shows-module__text'>
                        <div className='cam-shows-module__text-container'>
                            <h2 className='cam-shows-module__text-title'><span>CAM</span>SHOWS</h2>
                            <div className='cam-shows-module__text-text'>{getTranslation('module-subline')}</div>
                            <div className='cam-shows-module__text-button'>
                                {this.getButton()}
                            </div>
                        </div>
                    </div>
                    <div className='cam-shows-module__featured'>{hasFeatured &&
                        <CamShowsFeatured items={this.state.featuredShows} isMobile={this.state.isMobile} isModule={true}
                                        lazyImageLoading={this.props.lazyImageLoading}/>}</div>
                    <div className='cam-shows-module__next'>
                        {hasShows && <div className='cam-shows-module__next-container'>
                            <div className='cam-shows-module__next-text'>{getTranslation('module-next-show')}</div>
                            <CamShowsItem parent='featured' item={this.state.shows[0]} isModule={true} lazyImageLoading={this.props.lazyImageLoading}/>
                        </div>}
                        <div className='cam-shows-module__next-button'>
                            {this.getButton()}
                        </div>
                    </div>
                </section>
            )
		);
	}
}

CamShowsBlock.propTypes = {
	parentCallback:   PropTypes.func,
	lazyImageLoading: PropTypes.bool
};


export default CamShowsBlock;
